<div class="modal-header">
  <h4 class="modal-title">{{ editTitle }} {{ PersonName }} Earnings</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-sm-6 row">
      <div class="col-auto my-auto">
        <div class="fw-bold form-label">Salary</div>
      </div>
      <div class="col">
        <input appNumberInput class="form-control mb-0" [(ngModel)]="SalaryValue" />
      </div>
    </div>
    <div class="col-sm-6 row">
      <div class="col-auto my-auto">
        <div class="fw-bold form-label">Regular</div>
      </div>
      <div class="col">
        <input appNumberInput class="form-control mb-0" [(ngModel)]="RegValue" />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer pb-4">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
  <div>
    <button type="button" class="btn btn-primary" (click)="onSave(activeModal)">
      Save Changes
    </button>
  </div>
</div>
